import { DEV } from "solid-js"
import { freeze } from "../util/Object"

export const DIJKSTRA_DIRECTION_SOUTH_INDEX = 0
export const DIJKSTRA_DIRECTION_EAST_INDEX = 1
export const DIJKSTRA_DIRECTION_NORTH_INDEX = 2
export const DIJKSTRA_DIRECTION_WEST_INDEX = 3

const dijkstraDirectionCharsLowerCase = [
  's',
  'e',
  'n',
  'w',
] as const

if (DEV) {
  freeze(dijkstraDirectionCharsLowerCase)
}

export default dijkstraDirectionCharsLowerCase